import OkButton from "../../../common/Button/OKButton/OKButton";

import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import "./TripApprovalResult.scss";
// ─── Icons ────────────────────────────────────────────────────────────────────

function IconApproved() {
    return (
        <div className="trip-approval-icon__circle trip-approval-icon__circle--approved">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="#2ecc71" strokeWidth="2.2"
                      strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}

function IconRejected() {
    return (
        <div className="trip-approval-icon__circle trip-approval-icon__circle--rejected">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
                <circle cx="28" cy="28" r="20" stroke="#e53e3e" strokeWidth="2" fill="none" />
                <path d="M21 21l14 14M35 21L21 35" stroke="#e53e3e" strokeWidth="2.2"
                      strokeLinecap="round" />
            </svg>
        </div>
    );
}

function IconError() {
    return (
        <div className="trip-approval-icon__circle trip-approval-icon__circle--error">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M24 4L42 36H6L24 4Z" stroke="#e53e3e" strokeWidth="2"
                      fill="none" strokeLinejoin="round" />
                <path d="M24 18v8" stroke="#e53e3e" strokeWidth="2.2" strokeLinecap="round" />
                <circle cx="24" cy="30" r="1.5" fill="#e53e3e" />
            </svg>
        </div>
    );
}

// ─── Screen configs ───────────────────────────────────────────────────────────

const SCREENS = {
    approved: {
        icon: <IconApproved />,
        title: "КОМАНДИРОВКА СОГЛАСОВАНА",
        subtitle: "Вы успешно согласовали заявку сотрудника.\nИнформация передана в систему.",
    },
    rejected: {
        icon: <IconRejected />,
        title: "ЗАЯВКА ОТКЛОНЕНА",
        subtitle: "Ваше решение зафиксировано и передано в систему.",
    },
    error: {
        icon: <IconError />,
        title: "НЕ УДАЛОСЬ\nОБРАБОТАТЬ ЗАПРОС",
        subtitle: "Во время обработки решения произошла ошибка.\nПопробуйте позже или войдите в личный кабинет.",
    },
};

// ─── Main Component ───────────────────────────────────────────────────────────

/**
 * TripApprovalResult
 *

 * URL query params:
 *   ?approved=true   → «Командировка согласована»
 *   ?approved=false  → «Заявка отклонена»
 *   (без параметра)  → «Не удалось обработать запрос»
 */
export default function TripApprovalResult() {
    const navigate = useNavigate();
    const screen = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const approved = params.get("approved");
        if (approved === "true") return "approved";
        if (approved === "false") return "rejected";
        return "error";
    }, []);

    const { icon, title, subtitle } = SCREENS[screen];

    return (
        <div className="trip-approval-page">
            <div className="trip-approval-card">

                <div className="trip-approval-icon">
                    {icon}
                </div>

                <h1 className="trip-approval-title">{title}</h1>

                <p className="trip-approval-subtitle">{subtitle}</p>

                <div className="trip-approval-buttons">
                    <OkButton
                        title={"ВОЙТИ В ЛК"}
                        handler={()=> navigate("/start")}/>
                </div>

            </div>
        </div>
    );
}
